import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';

interface ComponentTab {
  label: string;
  route: string;
}

@Component({
  selector: 'app-component-playground',
  imports: [MatTabsModule, RouterModule, MatListModule, MatGridListModule],
  templateUrl: './component-playground.component.html',
  styleUrls: ['./component-playground.component.scss'],
})
export class ComponentPlaygroundComponent {
  components: ComponentTab[] = [
    { label: 'Accordion', route: './accordion' },
    { label: 'Alerts', route: './alerts' },
    { label: 'Async Actionable Selector', route: './actionable-selector' },
    { label: 'Async Selector', route: './async-selector' },
    { label: 'Autocomplete', route: './autocomplete' },
    { label: 'Avatar', route: './avatar' },
    { label: 'Badges', route: './badges' },
    { label: 'Button', route: './button' },
    { label: 'Card List', route: './card-list' },
    { label: 'Carousel', route: './carousel' },
    { label: 'Charts', route: './charts' },
    { label: 'Chips', route: './chips' },
    { label: 'Colors', route: './colors' },
    { label: 'Dashboard', route: './dashboard' },
    { label: 'Date Picker', route: './date-picker' },
    { label: 'Dialog', route: './dialog' },
    { label: 'Directives', route: './directives' },
    { label: 'Divider', route: './divider' },
    { label: 'Drawer', route: './drawer' },
    { label: 'Empty State', route: './empty-state' },
    { label: 'Field', route: './field' },
    { label: 'Loading', route: './loading' },
    { label: 'Logo', route: './logo' },
    { label: 'Mat Chip Tab', route: './mat-chip-tab' },
    { label: 'Mat Range Input', route: './mat-range-input' },
    { label: 'Menu', route: './menu' },
    { label: 'No Data', route: './no-data' },
    { label: 'Page Header', route: './page-header' },
    { label: 'Pipes', route: './pipes' },
    { label: 'Retry Component', route: './retry-component' },
    { label: 'Search', route: './search' },
    { label: 'Selection Controls', route: './selection-controls' },
    { label: 'Slider', route: './slider' },
    { label: 'Spacing', route: './spacing' },
    { label: 'Status', route: './status' },
    { label: 'Steps', route: './steps' },
    { label: 'Tables', route: './tables' },
    { label: 'Tabs', route: './tabs' },
    { label: 'Time Picker', route: './time-picker' },
    { label: 'Toast', route: './toast' },
    { label: 'Tooltip', route: './tooltip' },
    { label: 'Typography', route: './typography' },
    { label: 'Upload File', route: './upload-file' },
    { label: 'QR Code Generator', route: './qr-code-generator' },
    { label: 'Alert', route: './alert' },
  ];
}
